var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptoCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 51,
    viewBox: "0 0 85 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7439 49.6534L6.02729 37.7987C4.00998 37.0894 3.99953 34.2402 6.01158 33.5161L42.6574 20.3286C43.1655 20.1458 43.722 20.1498 44.2273 20.3399L79.2802 33.5276C81.2514 34.2692 81.2408 37.0613 79.264 37.7879L47.1262 49.6012C44.7463 50.476 42.136 50.4944 39.7439 49.6534Z",
    stroke: "#00FF94",
    strokeWidth: 0.737374
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6208 46.7862L10.4272 36.9222C9.16172 36.522 9.15569 34.7333 10.4185 34.3246L42.8733 23.8206C43.1521 23.7304 43.4526 23.7324 43.7302 23.8263L74.7741 34.3304C76.0141 34.7499 76.008 36.5059 74.7651 36.9168L44.9775 46.7643C43.8887 47.1243 42.7142 47.1319 41.6208 46.7862Z",
    fill: "#203376"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6223 27.1401L51.7697 24.7402L49.4062 38.5908L62.6223 27.1401Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.419829,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.621 23.2007L51.8606 20.8306L49.4062 38.5889L61.621 23.2007Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.419829,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3337 13.711L53.8714 11.7959L49.4062 38.5907L59.3337 13.711Z",
    fill: "#00FF94",
    stroke: "#101118",
    strokeWidth: 0.419829,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30.6603L30.4037 1.04541L56.6976 8.58749L49.4322 38.6179L23 30.6603Z",
    fill: "white",
    stroke: "#101118",
    strokeWidth: 0.419829,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0312 31.5519L32.5217 4.88135L52.7374 10.8394L46.3079 37.6426L26.0312 31.5519Z",
    stroke: "#101118",
    strokeWidth: 0.419829,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9498 17.7054C38.3419 17.7622 38.7425 17.7049 39.1012 17.5405C39.4598 17.3761 39.7603 17.1121 39.9648 16.7817C40.1692 16.4514 40.2685 16.0696 40.25 15.6844C40.2315 15.2993 40.0961 14.9281 39.8609 14.6178C39.6257 14.3074 39.3012 14.0718 38.9284 13.9406C38.5556 13.8094 38.151 13.7886 37.7661 13.8808C37.3811 13.9729 37.0329 14.1739 36.7653 14.4584C36.4977 14.7429 36.3227 15.0981 36.2625 15.4792C36.2224 15.7332 36.2342 15.9924 36.2974 16.2419C36.3605 16.4914 36.4738 16.7263 36.6306 16.9332C36.7874 17.14 36.9846 17.3147 37.211 17.4472C37.4374 17.5797 37.6884 17.6675 37.9498 17.7054Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.419829,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0718 23.2406C42.462 23.2957 42.8602 23.2372 43.2164 23.0725C43.5725 22.9079 43.8705 22.6443 44.0728 22.3152C44.2752 21.9861 44.373 21.6061 44.3536 21.2231C44.3343 20.8401 44.1987 20.4712 43.9642 20.1629C43.7296 19.8547 43.4066 19.6209 43.0356 19.4909C42.6646 19.361 42.2623 19.3407 41.8795 19.4327C41.4967 19.5247 41.1505 19.7248 40.8844 20.0079C40.6184 20.291 40.4444 20.6442 40.3845 21.0233C40.3445 21.2767 40.3563 21.5354 40.4196 21.7844C40.4829 22.0333 40.5963 22.2676 40.7532 22.4738C40.91 22.6799 41.1072 22.8538 41.3335 22.9854C41.5599 23.117 41.8108 23.2038 42.0718 23.2406Z",
    fill: "white",
    stroke: "#292B38",
    strokeWidth: 0.419829,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7422 21.7677L44.9719 15.2842L35.7422 21.7677Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7422 21.7677L44.9719 15.2842",
    stroke: "#292B38",
    strokeWidth: 0.419829,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3263 36.4042L29.4414 32.5339C29.4756 32.2367 29.5319 31.9389 29.6114 31.642C30.5341 28.1985 34.2346 26.1981 37.8768 27.174C41.5189 28.1499 43.7235 31.7326 42.8008 35.1761C42.6847 35.6094 42.5247 36.0197 42.3263 36.4042Z",
    fill: "#00FF94"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3263 36.4042L42.2659 36.6053C42.3627 36.6344 42.4665 36.5903 42.5128 36.5005L42.3263 36.4042ZM29.4414 32.5339L29.2329 32.5099C29.2213 32.6109 29.2837 32.7057 29.381 32.7349L29.4414 32.5339ZM29.6114 31.642L29.4086 31.5877H29.4086L29.6114 31.642ZM37.8768 27.174L37.9311 26.9712L37.8768 27.174ZM42.8008 35.1761L43.0036 35.2305L42.8008 35.1761ZM42.3867 36.2032L29.5018 32.3329L29.381 32.7349L42.2659 36.6053L42.3867 36.2032ZM29.6499 32.5579C29.6829 32.2709 29.7373 31.9832 29.8142 31.6964L29.4086 31.5877C29.3264 31.8945 29.2682 32.2026 29.2329 32.5099L29.6499 32.5579ZM29.8142 31.6964C30.704 28.3754 34.2814 26.4279 37.8225 27.3767L37.9311 26.9712C34.1878 25.9682 30.3642 28.0216 29.4086 31.5877L29.8142 31.6964ZM37.8225 27.3767C41.3635 28.3256 43.4879 31.8008 42.598 35.1218L43.0036 35.2305C43.9591 31.6644 41.6744 27.9742 37.9311 26.9712L37.8225 27.3767ZM42.598 35.1218C42.4859 35.5404 42.3313 35.9367 42.1397 36.308L42.5128 36.5005C42.7181 36.1028 42.8836 35.6783 43.0036 35.2305L42.598 35.1218Z",
    fill: "#101118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoCards);
export default __webpack_public_path__ + "static/media/cryptoCards.8de4c945d62098c8e6883f3a4f04a208.svg";
export { ForwardRef as ReactComponent };